import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the create), not a
 * state transition (the saga owns the resulting `save*` transitions).
 */

/** Submit the current draft (dispatched when the user clicks Save). */
export const submitRequested = createAction('addLicence/submitRequested');

/** Load who may be picked as the Customer Success Manager (dispatched when the form opens, #583). */
export const csmCandidatesRequested = createAction('addLicence/csmCandidatesRequested');

/** Load the client category list (dispatched when the form opens, #604). */
export const clientCategoriesRequested = createAction('addLicence/clientCategoriesRequested');

/** Add a client category from the select, then pick it (Administrator only, #604). */
export const clientCategoryAddRequested = createAction<string>('addLicence/clientCategoryAddRequested');
